/// <amd-module name="Test/TestResultsGridToolbar/Source/TestResultToolBarSource" />
import * as Common from "Test/common-util/Common"
import * as TestManagementService from "Test/Client/TestManagementServices"
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { IVssPageContext } from "VSS/Platform/Context";
import { TestResultsFieldDetailsWithContinuationToken } from "Test/common-util/Contracts/ExtendedTest";
import { FilterByFields } from "Test/common-util/Common";
import { TestTag } from "Test/common-util/Contracts/Test";

export class TestResultToolBarSource {
    public constructor(private pageContext: IVssPageContext) { }

    public getTestResultsFieldValues(artifact: Common.IViewContextData, continuationToken?: string): Promise<TestResultsFieldDetailsWithContinuationToken> {
        let currentArtifact = artifact.data.mainData;
        let tcmService = this.pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        let fields = [FilterByFields.Container, FilterByFields.Owner];

        if (artifact.viewContext === Common.ViewContext.Build) {
            return tcmService.getResultGroupsByBuild(currentArtifact.id, Common.SourceWorkflow.BUILD_SOURCE_WORKFLOW, fields, continuationToken);
        } else {
            let filters = (artifact.data.subData) ? artifact.data.subData : null,
                selectedEnvironmentId = (filters && filters.environment) ? filters.environment.id : null;

            return tcmService.getResultGroupsByRelease(currentArtifact.id, selectedEnvironmentId, Common.SourceWorkflow.RELEASE_SOURCE_WORKFLOW, fields, continuationToken);
        }
    }

    public getTestTagsForBuildOrRelease(artifact: Common.IViewContextData): Promise<TestTag[]> {
        let currentArtifact = artifact.data.mainData;
        let tcmService = this.pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);

        if (artifact.viewContext === Common.ViewContext.Build) {
            return tcmService.getTestTagsForBuild(currentArtifact.id);
        } else {
            let filters = (artifact.data.subData) ? artifact.data.subData : null,
                selectedEnvironmentId = (filters && filters.environment) ? filters.environment.id : null;

            return tcmService.getTestTagsForRelease(currentArtifact.id, selectedEnvironmentId);
        }
    }

    public getTestResultsSettings(context: IVssPageContext): Promise<TCMContracts.TestResultsSettings> {
        let tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        return tcmService.getTestResultsSettings(TCMContracts.TestResultsSettingsType.Flaky);
    }
}
